import axios from 'axios';
import Cookies from 'js-cookie'
import baseConfig from '../config/baseConfig';
import { Toast } from 'antd-mobile'

axios.defaults.baseURL = baseConfig.baseUrl
// axios.defaults.timeout = 6000

// 拦截器，加入token
axios.interceptors.request.use(async config => { //拦截器处理
    let token = Cookies.get('authorization');
    config.headers['authorization'] = token;
    return config;
})

export default class http {
    // post暂未封装
    //   static async get(url, params) {
    //     /**
    //      * params{
    //      *  goods：id，
    //      *  name：string
    //      * } ==> ?goods=id&name=string
    //      */
    //     try {
    //       let query = await qs.stringify(params)
    //       let res = null;
    //       if (!params) {
    //         res = await axios.get(url)
    //       } else {
    //         res = await axios.get(url + '?' + query)
    //       }
    //       return res.data
    //     } catch (error) {
    //       return error
    //     }
    //   }
    static async post(url, params = {}) {
        try {
            if (params) {
                // params.app_device = 'lite';//'H5';//'IOS';
                params.app_device = 'H5';//'IOS';
                params.app_version = '1.0.0';
                params.merchant_id = global.constants.merchant_id;
                params.custom_id = global.constants.custom_id;
            }
            let res = await axios.post(url, params)
            return res.data
        } catch (error) {
            alert(error)
            // Toast.info(error, 1)
            return error
        }
    }
}